module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/act/sections/instructors/assets/kat_headshot-93ed19ecf3980d9343916dda22c6a840.png";